<template>
  <div class="row">
    <div class="col-24 col-md-17">
      <div v-if="program.description" class="card mb-3">
        <div class="card-header" v-text="$ml.get('summary')">Resumo</div>

        <div class="card-body" v-text="program.description"></div>
      </div>
      <div class="card card-no mb-3">
        <div class="card-body">
          <div class="d-column flex-row">
            <div
              class="h-form h-profile-lg d-flex flex-column pb-3 align-items-center no"
            >
              <!-- Config -->
              <div
                v-if="$store.getters['getUserType'] == 'company'"
                class="w-100"
              >
                <div class="d-flex align-self-start">
                  <div
                    class="position-relative align-self-center d-flex align-items-center align-self-center"
                  >
                    <div
                      class="circle-number d-flex justify-content-center align-items-center"
                    >
                      <span>1</span>
                    </div>
                  </div>
                  <div class="pl-3 d-flex">
                    <div class="align-self-start mt-1">
                      <h2 class="size-1_4 m-0 pb-1">
                        <strong v-text="$ml.get('settings')"
                          >Configuração</strong
                        >
                      </h2>
                      <p class="d-flex align-items-center">
                        <span
                          class="align-self-center"
                          v-text="
                            $ml.get(
                              'theseSettingsDirectlyImpactTheAccessOfExperts',
                            )
                          "
                        >
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-self-start h-profile">
                  <div class="v-line d-flex align-items-stretch">
                    <span class="pb-4"></span>
                  </div>
                </div>

                <div class="d-flex align-self-start h-profile-circle">
                  <div class="circle d-flex justify-content-center flex-row">
                    <span class="circle-internal d-flex justify-content-center"
                      ><span class="circle-primary"></span
                    ></span>
                    <div class="h-line"><span></span></div>
                    <div class="v-line"><span></span></div>
                  </div>
                  <div class="d-flex flex-column w-100 mr-3 pl-3">
                    <div class="col-14 pb-2">
                      <h6
                        v-if="program.type == 'public'"
                        v-text="$ml.get('ccpProgPubli')"
                      >
                        Programa Público
                      </h6>
                      <h6
                        v-else-if="program.type == 'vdp'"
                        v-text="'Vulnerability Disclosure Program'"
                      ></h6>
                      <h6 v-else v-text="$ml.get('ccpProgPriv')">
                        Programa Privado
                      </h6>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-self-start h-profile">
                  <div class="v-line d-flex align-items-stretch">
                    <span class="pb-4"></span>
                  </div>
                </div>

                <div
                  v-if="program.slug && program.type != 'private' && program.exposed" 
                  class="d-flex align-self-start h-profile-circle"
                >
                  <div class="circle d-flex justify-content-center flex-row">
                    <span class="circle-internal d-flex justify-content-center"
                      ><span class="circle-primary"></span
                    ></span>
                    <div class="h-line"><span></span></div>
                    <div class="v-line"><span></span></div>
                  </div>
                  <div class="d-flex flex-column w-100 mr-3 pl-3">
                    <div class="col-24 pb-2">
                      <input
                        class="input-none"
                        id="inputSlug"
                        :value="url + '/' + program.slug"
                      />
                      <VueCustomTooltip :label="textTolltip">
                        <a
                          @click="copyLink()"
                          @mouseout="textTolltip = 'Copiar link'"
                          class="pointer row"
                        >
                          <h6>{{ url }}/{{ program.slug }}</h6>
                          <!-- <svg width="17" height="17" class="mx-2">
                            <image
                              xlink:href="../assets/icons/share-node.svg"
                              width="17"
                              height="17"
                            />
                          </svg> -->
                        </a>
                      </VueCustomTooltip>
                    </div>
                  </div>
                </div>
                <div
                  v-if="program.slug && program.type != 'private'"
                  class="d-flex align-self-start h-profile"
                >
                  <div class="v-line d-flex align-items-stretch">
                    <span class="pb-4"></span>
                  </div>
                </div>
                <!-- Objetivo do programa -->
                <div
                  class="d-flex align-self-start"
                  v-if="program?.target_settings?.active"
                >
                  <div
                    class="position-relative align-self-center d-flex align-items-center align-self-center"
                  >
                    <div
                      class="circle-number d-flex justify-content-center align-items-center"
                    >
                      <span>2</span>
                    </div>
                  </div>
                  <div class="pl-3 d-flex">
                    <div class="align-self-start mt-1">
                      <h2 class="size-1_4 m-0 pb-1">
                        <strong>Objetivo do Programa</strong>
                      </h2>
                      <p class="d-flex align-items-center">
                        <span
                          class="align-self-center"
                          v-text="$ml.get('aGoodObjectiveAvoids')"
                        >
                          Um objetivo bem definido evita problemas, caso tenha
                          algum problema nos consulte.
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex align-self-start h-profile"
                  v-if="program?.target_settings?.active"
                >
                  <div class="v-line d-flex align-items-stretch">
                    <span class="pb-1"></span>
                  </div>
                </div>
                <div
                  class="d-flex align-self-start h-profile"
                  v-if="program?.target_settings?.active"
                >
                  <div
                    class="v-line d-flex align-items-stretch"
                    v-if="program?.target_settings?.active"
                  >
                    <span class="pb-4"></span>
                  </div>
                </div>
                <div
                  class="d-flex align-self-start h-profile-circle"
                  v-if="program?.target_settings?.active"
                >
                  <div class="circle d-flex justify-content-center">
                    <span class="circle-internal d-flex justify-content-center"
                      ><span class="circle-primary"></span
                    ></span>
                    <div class="h-line"><span></span></div>
                    <div class="v-line"><span></span></div>
                  </div>
                  <div v-if="!isThereATarget && !targetFinishedAt">
                    <p class="pl-3" v-text="$ml.get('noObjectivesAvailable')">
                      Nenhum objetivo disponível!
                    </p>
                    <div style="height: 50px"></div>
                  </div>
                  <div v-else class="d-flex flex-column w-100 mr-3 pb-5">
                    <div class="position-relative">
                      <p
                        class="pl-3 mb-3 col-24"
                        v-text="$ml.get('aboutTarget')"
                      >
                        Sobre o objetivo do programa!
                      </p>
                      <svg
                        v-if="program.policy != program?.translated_policy"
                        v-b-tooltip.hover
                        :title="$ml.get('seeOriginalText')"
                        @click="showOriginalText = !showOriginalText"
                        width="25"
                        height="25"
                        class="mx-2 icon-aa-svg"
                      >
                        <image
                          xlink:href="../assets/svg/aa.svg"
                          width="25"
                          height="25"
                        />
                      </svg>
                    </div>
                    <div class="card card-body mx-md-3 d-flex w-100 px-3">
                      <div class="d-flex flex-column w-100">
                        <div
                          class="form-control h-100 mb-2"
                          style="position: relative"
                          v-for="(program, index) in program.target_settings
                            .targets"
                          :key="index"
                        >
                          <p
                            v-if="program.finishedAt"
                            style="
                              font-size: 0.8rem !important;
                              color: #888888d9;
                            "
                            class="text-right m-0"
                          >
                            {{ $ml.get("reachedIn") }}:
                            {{ $utils.formatDataShort(program.finishedAt) }}
                          </p>
                          <p
                            v-if="program.title"
                            style="font-weight: 500"
                            :style="{
                              textDecoration: program.finishedAt
                                ? 'line-through'
                                : '',
                            }"
                          >
                            {{ program.title }}
                          </p>

                          <p
                            :style="{
                              textDecoration: program.finishedAt
                                ? 'line-through'
                                : '',
                            }"
                            v-html="
                              $utils.convertMarkedOld(
                                showOriginalText
                                  ? program.policy
                                  : program.translated_policy,
                              )
                            "
                          ></p>
                          <p
                            :style="{
                              textDecoration: program.finishedAt
                                ? 'line-through'
                                : '',
                            }"
                            class="mt-3"
                          >
                            <span
                              class="bounty"
                              v-if="program.currency.toUpperCase() === 'BRL'"
                            >
                              {{ $utils.convertMoney(program.bounty) }}
                            </span>
                            <span v-else class="bounty">
                              {{ $utils.convertDollar(program.bounty) }}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Policy -->
                <div class="d-flex align-self-start">
                  <div
                    class="position-relative align-self-center d-flex align-items-center align-self-center"
                  >
                    <div
                      class="circle-number d-flex justify-content-center align-items-center"
                    >
                      <span>{{
                        program?.target_settings?.active ? "3" : "2"
                      }}</span>
                    </div>
                  </div>
                  <div class="pl-3 d-flex">
                    <div class="align-self-start mt-1">
                      <h2 class="size-1_4 m-0 pb-1">
                        <strong v-text="$ml.get('programPolicy')"
                          >Política do Programa</strong
                        >
                      </h2>
                      <p class="d-flex align-items-center">
                        <span
                          class="align-self-center"
                          v-text="$ml.get('aGoodPolicAvoids')"
                        >
                          Uma boa política evita problemas, caso tenha algum
                          problema nos consulte.
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-self-start h-profile">
                  <div class="v-line d-flex align-items-stretch">
                    <span class="pb-1"></span>
                  </div>
                </div>
                <div class="d-flex align-self-start h-profile">
                  <div class="v-line d-flex align-items-stretch">
                    <span class="pb-4"></span>
                  </div>
                </div>
                <div class="d-flex align-self-start h-profile-circle">
                  <div class="circle d-flex justify-content-center">
                    <span class="circle-internal d-flex justify-content-center"
                      ><span class="circle-primary"></span
                    ></span>
                    <div class="h-line"><span></span></div>
                    <div class="v-line"><span></span></div>
                  </div>
                  <div class="d-flex flex-column w-100 mr-3 pb-5">
                    <div class="position-relative">
                      <p
                        class="pl-3 mb-3 col-24"
                        v-text="$ml.get('aboutTheProgramPolicy')"
                      >
                        Sobre a política do programa!
                      </p>
                      <svg
                        v-if="
                          $utils.convertMarkedOld(program.policy) !=
                          $utils.convertMarkedOld(program.translated_policy)
                        "
                        v-b-tooltip.hover
                        :title="
                          showOriginalText
                            ? $ml.get('translateText')
                            : $ml.get('seeOriginalText')
                        "
                        @click="showOriginalText = !showOriginalText"
                        width="25"
                        height="25"
                        class="mx-2 icon-aa-svg"
                      >
                        <image
                          xlink:href="../assets/svg/aa.svg"
                          width="25"
                          height="25"
                        />
                      </svg>
                    </div>
                    <div class="card card-body mx-md-3 d-flex w-100 px-3">
                      <div class="d-flex flex-column w-100">
                        <div class="form-control h-100">
                          <p
                            v-if="program.policy"
                            v-html="
                              $utils.convertMarkedOld(
                                showOriginalText
                                  ? program.policy
                                  : program.translated_policy,
                              )
                            "
                          ></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="w-100">
                <!-- Objetivo do programa -->
                <div
                  class="d-flex align-self-start"
                  v-if="program.target_settings?.active"
                >
                  <div
                    class="position-relative align-self-center d-flex align-items-center align-self-center"
                  >
                    <div
                      class="circle-number d-flex justify-content-center align-items-center"
                    >
                      <span>1</span>
                    </div>
                  </div>
                  <div class="pl-3 d-flex">
                    <div class="align-self-start mt-1">
                      <h2 class="size-1_4 m-0 pb-1">
                        <strong>Objetivo do Programa</strong>
                      </h2>
                      <p class="d-flex align-items-center">
                        <span
                          class="align-self-center"
                          v-text="$ml.get('aGoodObjectiveAvoids')"
                        >
                          Um objetivo bem definido evita problemas, caso tenha
                          algum problema nos consulte.
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex align-self-start h-profile"
                  v-if="program.target_settings?.active"
                >
                  <div class="v-line d-flex align-items-stretch">
                    <span class="pb-1"></span>
                  </div>
                </div>
                <div
                  class="d-flex align-self-start h-profile"
                  v-if="program?.target_settings?.active"
                >
                  <div
                    class="v-line d-flex align-items-stretch"
                    v-if="program?.target_settings?.active"
                  >
                    <span class="pb-4"></span>
                  </div>
                </div>
                <div
                  class="d-flex align-self-start h-profile-circle"
                  v-if="program?.target_settings?.active"
                >
                  <div class="circle d-flex justify-content-center">
                    <span class="circle-internal d-flex justify-content-center"
                      ><span class="circle-primary"></span
                    ></span>
                    <div class="h-line"><span></span></div>
                    <div class="v-line"><span></span></div>
                  </div>
                  <div v-if="!isThereATarget">
                    <p class="pl-3" v-text="$ml.get('noObjectivesAvailable')">
                      Nenhum objetivo disponível!
                    </p>
                    <div style="height: 50px"></div>
                  </div>
                  <div v-else class="d-flex flex-column w-100 mr-3 pb-5">
                    <div class="position-relative">
                      <p
                        class="pl-3 mb-3 col-24"
                        v-text="$ml.get('aboutTarget')"
                      >
                        Sobre o objetivo do programa!
                      </p>
                      <svg
                        v-if="program.policy != program?.translated_policy"
                        v-b-tooltip.hover
                        :title="$ml.get('seeOriginalText')"
                        @click="showOriginalText = !showOriginalText"
                        width="25"
                        height="25"
                        class="mx-2 icon-aa-svg"
                      >
                        <image
                          xlink:href="../assets/svg/aa.svg"
                          width="25"
                          height="25"
                        />
                      </svg>
                    </div>
                    <div class="card card-body mx-md-3 d-flex w-100 px-3">
                      <div class="d-flex flex-column w-100">
                        <div
                          class="mb-3"
                          v-for="(program, index) in program.target_settings
                            .targets"
                          :key="index"
                        >
                          <div
                            class="form-control h-100 mb-2"
                            style="position: relative"
                            v-if="!program.finishedAt"
                          >
                            <p style="font-weight: 500">{{ program.title }}</p>
                            <p
                              v-html="
                                $utils.convertMarkedOld(
                                  showOriginalText
                                    ? program.policy
                                    : program.translated_policy,
                                )
                              "
                            ></p>
                            <p class="mt-3">
                              <span
                                class="bounty"
                                v-if="program.currency.toUpperCase() === 'BRL'"
                              >
                                {{ $utils.convertMoney(program.bounty) }}
                              </span>
                              <span v-else class="bounty">
                                {{ $utils.convertDollar(program.bounty) }}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--1 Hacker Policy -->
                <div class="d-flex align-self-start">
                  <div
                    class="position-relative align-self-center d-flex align-items-center align-self-center"
                  >
                    <div
                      class="circle-number d-flex justify-content-center align-items-center"
                    >
                      <span>{{
                        program?.target_settings?.active ? 2 : 1
                      }}</span>
                    </div>
                  </div>
                  <div class="pl-3 d-flex">
                    <div class="align-self-start mt-1">
                      <h2 class="size-1_4 m-0 pb-1">
                        <strong v-text="$ml.get('programPolicy')"
                          >Política do Programa</strong
                        >
                      </h2>
                      <p
                        class="d-flex align-items-center"
                        v-if="$store.getters['getUserType'] == 'company'"
                      >
                        <span
                          class="align-self-center"
                          v-text="$ml.get('aGoodPolicAvoids')"
                        >
                          Uma boa política evita problemas, caso tenha algum
                          problema nos consulte.
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-self-start h-profile">
                  <div class="v-line d-flex align-items-stretch">
                    <span class="pb-4"></span>
                  </div>
                </div>
                <div class="d-flex align-self-start h-profile-circle">
                  <div class="circle d-flex justify-content-center flex-row">
                    <span class="circle-internal d-flex justify-content-center"
                      ><span class="circle-primary"></span
                    ></span>
                    <div class="h-line"><span></span></div>
                    <div class="v-line"><span></span></div>
                  </div>
                  <div class="d-flex flex-column w-100 mr-3 pl-3">
                    <div class="col-14 pb-2">
                      <h6
                        v-if="program.type == 'public'"
                        v-text="$ml.get('ccpProgPubli')"
                      >
                        Programa Público
                      </h6>
                      <h6
                        v-else-if="program.type == 'vdp'"
                        v-text="'Vulnerability Disclosure Program'"
                      ></h6>
                      <h6 v-else v-text="$ml.get('ccpProgPriv')">
                        Programa Privado
                      </h6>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-self-start h-profile">
                  <div class="v-line d-flex align-items-stretch">
                    <span class="pb-4"></span>
                  </div>
                </div>
                <div class="d-flex align-self-start h-profile-circle">
                  <div class="circle d-flex justify-content-center">
                    <span class="circle-internal d-flex justify-content-center"
                      ><span class="circle-primary"></span
                    ></span>
                    <div class="h-line"><span></span></div>
                    <div class="v-line"><span></span></div>
                  </div>
                  <div class="d-flex flex-column w-100 mr-3">
                    <div class="position-relative">
                      <p
                        class="pl-3 mb-3"
                        v-text="$ml.get('aboutTheProgramPolicy')"
                        v-if="$store.getters['getUserType'] == 'company'"
                      >
                        Sobre a política do programa!
                      </p>
                      <p
                        class="pl-3 mb-3"
                        v-text="$ml.get('aboutTheProgramPolicyHacker')"
                        v-else
                      >
                        As regras contidas na política do programa devem ser
                        respeitadas!
                      </p>
                      <svg
                        v-if="program.policy != program.translated_policy"
                        v-b-tooltip.hover
                        :title="$ml.get('seeOriginalText')"
                        @click="showOriginalText = !showOriginalText"
                        width="25"
                        height="25"
                        class="mx-2 icon-aa-svg"
                      >
                        <image
                          xlink:href="../assets/svg/aa.svg"
                          width="25"
                          height="25"
                        />
                      </svg>
                    </div>
                    <div class="card card-body mx-md-3 d-flex w-100 px-3">
                      <div class="d-flex flex-column w-100">
                        <div class="form-control h-100">
                          <p
                            v-if="program.policy"
                            v-html="
                              $utils.convertMarkedOld(
                                showOriginalText
                                  ? program.policy
                                  : program.translated_policy,
                              )
                            "
                          ></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-self-start h-profile">
                  <div class="v-line d-flex align-items-stretch">
                    <span class="pb-5"></span>
                  </div>
                </div>
              </div>
              <!-- Scope -->
              <div class="d-flex align-self-start">
                <div
                  class="position-relative align-self-center d-flex align-items-center align-self-center"
                >
                  <div
                    class="circle-number d-flex justify-content-center align-items-center"
                  >
                    <span>{{
                      $store.getters["getUserType"] == "company" &&
                      program?.target_settings?.active
                        ? 4
                        : $store.getters["getUserType"] == "company"
                        ? 3
                        : program?.target_settings?.active
                        ? 3
                        : 2
                    }}</span>
                  </div>
                </div>
                <div class="pl-3 d-flex">
                  <div class="align-self-start mt-1">
                    <h2 class="size-1_4 m-0 pb-1">
                      <strong v-text="$ml.get('scope')">Escopo</strong>
                    </h2>
                    <p class="d-flex align-items-center">
                      <span
                        class="align-self-center"
                        v-text="$ml.get('scopeListOfTheProgram')"
                      >
                        Lista de escopo do programa!
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="d-flex align-self-start h-profile">
                <div class="v-line d-flex align-items-stretch">
                  <span class="pb-4"></span>
                </div>
              </div>
              <div class="d-flex align-self-start h-profile-circle">
                <div class="circle d-flex justify-content-center">
                  <span class="circle-internal d-flex justify-content-center"
                    ><span class="circle-primary"></span
                  ></span>
                  <div class="h-line"><span></span></div>
                  <div class="v-line"><span></span></div>
                </div>
                <div class="d-flex flex-column w-100 mr-3">
                  <p
                    class="pl-3 mb-3"
                    v-text="$ml.get('delimitationOfDomainsSubdomains')"
                  >
                    Delimitação de domínios, subdomínios, aplicativos e outros
                  </p>
                  <div class="card card-body ml-md-3 p-0 d-flex w-100">
                    <table class="mb-1">
                      <thead v-if="program.scope">
                        <tr>
                          <th class="col-9" v-text="$ml.get('scope')">
                            Escopo
                          </th>
                          <th class="col-8 pl-0" v-text="$ml.get('type')">
                            Tipo
                          </th>
                          <th
                            class="col-4 pl-0 text-truncate"
                            v-text="$ml.get('severity')"
                          >
                            Severidade
                          </th>
                          <th class="col-3 pl-0 text-truncate">Bounty</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-if="!program.scope || !program.scope?.length"
                          class="d-flex align-items-center justify-content-center"
                        >
                          <h6 class="my-3" v-text="$ml.get('noScopeAvailable')">
                            Nenhum escopo disponível!
                          </h6>
                        </tr>
                        <tr
                          v-else
                          v-for="(item, index) in program.scope"
                          :key="index"
                          :class="
                            compareDateWeek(item.createdAt) || 'new-scope'
                          "
                        >
                          <td class="col-9">
                            <strong v-if="!compareDateWeek(item.createdAt)"
                              ><mark><a v-text="item.description"></a></mark
                            ></strong>
                            <strong v-else
                              ><a v-text="item.description"></a
                            ></strong>
                            <br />
                            <div
                              class="mt-2"
                              v-if="item.scope_details"
                              style="max-width: 380px"
                            >
                              <p v-if="item.program_scope_translation.length" style="white-space: pre-wrap">
                                {{ item.program_scope_translation.filter((item) => item.language === language)[0].scope_details }}
                              </p>
                            </div>
                            <div
                              v-if="item?.scope_tags"
                              class="d-flex align-items-center mt-3"
                              style="gap: 10px; flex-wrap: wrap"
                            >
                              <div
                                v-for="(tag, index) in item.scope_tags"
                                :key="index"
                              >
                                <div class="tagsListReport">{{ tag }}</div>
                              </div>
                            </div>
                          </td>
                          <td
                            class="col-8 pl-0 text-muted"
                            v-if="!compareDateWeek(item.createdAt)"
                          >
                            <mark>{{ nameLang(item.type) }}</mark>
                          </td>
                          <td class="col-8 pl-0 text-muted" v-else>
                            {{ nameLang(item.type) }}
                          </td>
                          <td class="col-4 pl-0">
                            <Impact
                              class="d-flex mt-1"
                              :impact="'impact-' + item.severity"
                            />
                          </td>
                          <td class="col-3 pl-0">
                            <VueCustomTooltip
                              :label="$ml.get('eligible')"
                              v-if="item.offers_bounty"
                              class="row"
                            >
                              <img
                                class="img-money"
                                src="../assets/images/money.png"
                              />
                            </VueCustomTooltip>

                            <VueCustomTooltip
                              :label="$ml.get('notEligible')"
                              v-if="!item.offers_bounty"
                              class="row"
                            >
                              <img
                                class="img-money"
                                src="../assets/images/no-money.png"
                              />
                            </VueCustomTooltip>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="d-flex align-self-start h-profile">
                <div class="v-line d-flex align-items-stretch">
                  <span class=" "></span>
                </div>
              </div>
              <!-- Out of Scope -->
              <!-- <div class="d-flex align-self-start h-profile">
                <div class="v-line d-flex align-items-stretch">
                  <span class="pb-5"></span>
                </div>
              </div>
              <div
                v-if="program.outOfScope?.length > 0"
                class="d-flex align-self-start"
              >
                <div
                  class="position-relative align-self-center d-flex align-items-center align-self-center"
                >
                  <div
                    class="circle-number d-flex justify-content-center align-items-center"
                  >
                    <span>{{
                      $store.getters["getUserType"] == "company" ? 4 : 3
                    }}</span>
                  </div>
                </div>
                <div class="pl-3 d-flex">
                  <div class="align-self-start mt-1">
                    <h2 class="size-1_4 m-0 pb-1">
                      <strong v-text="$ml.get('outOfScopeTitle')"
                        >Fora de Escopo</strong
                      >
                    </h2>
                    <p class="d-flex align-items-center">
                      <span
                        class="align-self-center"
                        v-text="$ml.get('limitOutOfScope')"
                      >
                        Quais aplicações não devem ser testadas?
                      </span>
                    </p>
                  </div>
                </div>
              </div> -->
              <!-- <div
                v-if="program.outOfScope?.length > 0"
                class="d-flex align-self-start h-profile"
              >
                <div class="v-line d-flex align-items-stretch">
                  <span class="pb-4"></span>
                </div>
              </div> -->
              <!-- <div
                v-if="program.outOfScope?.length > 0"
                class="d-flex align-self-start h-profile-circle"
              >
                <div class="circle d-flex justify-content-center">
                  <span class="circle-internal d-flex justify-content-center"
                    ><span class="circle-primary"></span
                  ></span>
                  <div class="h-line"><span></span></div>
                  <div class="v-line"><span></span></div>
                </div>
                <div class="d-flex flex-column w-100 mr-3">
                  <p
                    class="pl-3 mb-3"
                    v-text="$ml.get('delimitationOfDomainsSubdomains')"
                  >
                    Delimitação de domínios, subdomínios, aplicativos e outros
                  </p>
                  <div class="card card-body ml-md-3 p-0 d-flex w-100">
                    <table class="mb-1">
                      <thead v-if="program.scope">
                        <tr>
                          <th class="col-11" v-text="$ml.get('scope')">
                            Escopo
                          </th>
                          <th class="col-10 pl-0" v-text="$ml.get('type')">
                            Tipo
                          </th>
                          <th class="col-5 pl-0 text-truncate">Bounty</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-if="
                            !program.outOfScope || !program.outOfScope?.length
                          "
                          class="d-flex align-items-center justify-content-center"
                        >
                          <h6 class="my-3" v-text="$ml.get('noScopeAvailable')">
                            Nenhum escopo disponível!
                          </h6>
                        </tr>
                        <tr
                          v-else
                          v-for="item in program.outOfScope"
                          :key="item._id"
                          :class="
                            compareDateWeek(item.createdAt) || 'new-scope'
                          "
                        >
                          <td class="col-11">
                            <strong v-if="!compareDateWeek(item.createdAt)"
                              ><mark><a v-text="item.description"></a></mark
                            ></strong>
                            <strong v-else
                              ><a v-text="item.description"></a
                            ></strong>
                          </td>
                          <td
                            class="col-10 pl-0 text-muted"
                            v-if="!compareDateWeek(item.createdAt)"
                          >
                            <mark>{{ nameLang(item.type) }}</mark>
                          </td>
                          <td class="col-10 pl-0 text-muted" v-else>
                            {{ nameLang(item.type) }}
                          </td>
                          <td class="col-5 pl-0">
                            <VueCustomTooltip
                              :label="$ml.get('eligible')"
                              v-if="item.offers_bounty"
                              class="row"
                            >
                              <img
                                class="img-money"
                                src="../assets/images/money.png"
                              />
                            </VueCustomTooltip>

                            <VueCustomTooltip
                              :label="$ml.get('notEligible')"
                              v-if="!item.offers_bounty"
                              class="row"
                            >
                              <img
                                class="img-money"
                                src="../assets/images/no-money.png"
                              />
                            </VueCustomTooltip>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div> -->
              <div class="d-flex align-self-start h-profile">
                <div class="v-line d-flex align-items-stretch">
                  <span class=" "></span>
                </div>
              </div>

              <!-- Rewards -->
              <div
                v-if="
                  program.offers_bounty ||
                  (program.optional_rewards &&
                    program.optional_rewards?.length &&
                    !program?.target_settings?.active)
                "
                class="d-flex align-self-start h-profile"
              >
                <div class="v-line d-flex align-items-stretch">
                  <span class="pb-5"></span>
                </div>
              </div>
              <div
                v-if="
                  program.offers_bounty ||
                  (program.optional_rewards && program.optional_rewards?.length)
                "
                class="d-flex align-self-start"
              >
                <div
                  v-if="!program?.target_settings?.active"
                  class="position-relative align-self-center d-flex align-items-center align-self-center"
                >
                  <div
                    class="circle-number d-flex justify-content-center align-items-center"
                  >
                    <span>4</span>
                  </div>
                </div>
                <div
                  v-if="!program?.target_settings?.active"
                  class="pl-3 d-flex"
                >
                  <div class="align-self-start mt-1">
                    <h2 class="size-1_4 m-0 pb-1">
                      <strong v-text="$ml.get('rewards')">Recompensas</strong>
                    </h2>
                    <p class="d-flex align-items-center">
                      <span
                        class="align-self-center"
                        v-text="$ml.get('getAccessToExclusiveRewards')"
                      >
                        Tenha acesso à recompensas exclusivas deste programa!
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  program.offers_bounty && !program?.target_settings?.active
                "
                class="d-flex align-self-start h-profile"
              >
                <div class="v-line d-flex align-items-stretch">
                  <span class="pb-4"></span>
                </div>
              </div>
              <div
                v-if="
                  program.offers_bounty && !program?.target_settings?.active
                "
                class="d-flex align-self-start h-profile-circle"
              >
                <div class="circle d-flex justify-content-center">
                  <span class="circle-internal d-flex justify-content-center"
                    ><span class="circle-primary"></span
                  ></span>
                  <div class="h-line"><span></span></div>
                  <div class="v-line"><span></span></div>
                </div>
                <div class="d-flex flex-column w-100 mr-3">
                  <p
                    class="pl-3 mb-3"
                    v-text="$ml.get('rewardsWithFinancialValues')"
                  >
                    Recompensas com valores financeiros
                  </p>
                  <div class="card card-body ml-md-3 p-0 d-flex w-100">
                    <table class="mb-2">
                      <thead>
                        <tr>
                          <th
                            :class="[
                              'pl-3',
                              'pl-0',
                              {
                                'col-8':
                                  this.program.offers_double_bounty == true &&
                                  this.program.active_campaign,
                              },
                              {
                                'col-12':
                                  !this.program.active_campaign ||
                                  !this.program.offers_double_bounty,
                              },
                            ]"
                            v-text="$ml.get('severity')"
                          >
                            Severidade
                          </th>

                          <th
                            :class="[
                              'pl-0',
                              {
                                'col-8':
                                  this.program.offers_double_bounty == true &&
                                  this.program.active_campaign,
                              },
                              {
                                'col-12':
                                  !this.program.active_campaign ||
                                  !this.program.offers_double_bounty,
                              },
                            ]"
                            v-text="$ml.get('reward')"
                          >
                            Recompensa
                          </th>
                          <th
                            v-if="
                              this.program.offers_double_bounty == true &&
                              this.program.active_campaign
                            "
                            class="col-8 pl-0"
                            v-text="$ml.get('doubleReward')"
                          >
                            Recompensa em dobro
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="row">
                          <td
                            :class="[
                              'row',
                              {
                                'col-8':
                                  this.program.offers_double_bounty == true &&
                                  this.program.active_campaign,
                              },
                              {
                                'col-12':
                                  !this.program.active_campaign ||
                                  !this.program.offers_double_bounty,
                              },
                            ]"
                          >
                            <Impact class="mt-1 mr-1" impact="impact-low" />
                            <font v-text="$ml.get('low')">Baixo</font>
                          </td>
                          <td
                            :class="[
                              'pl-0',
                              {
                                'col-8':
                                  this.program.offers_double_bounty == true &&
                                  this.program.active_campaign,
                              },
                              {
                                'col-12':
                                  !this.program.active_campaign ||
                                  !this.program.offers_double_bounty,
                              },
                            ]"
                          >
                            <strong>{{
                              program.currency.toUpperCase() === "USDT"
                                ? $utils.convertDollar(program.bounty_low)
                                : $utils.convertMoney(program.bounty_low)
                            }}</strong>
                          </td>
                          <td
                            v-if="
                              this.program.offers_double_bounty == true &&
                              this.program.active_campaign
                            "
                            class="col-8 pl-0"
                          >
                            <strong>{{
                              program.currency.toUpperCase() === "USDT"
                                ? $utils.convertDollar(doubleBountyLow)
                                : $utils.convertMoney(doubleBountyLow)
                            }}</strong>
                          </td>
                        </tr>

                        <tr class="row">
                          <td
                            :class="[
                              'row',
                              {
                                'col-8':
                                  this.program.offers_double_bounty == true &&
                                  this.program.active_campaign,
                              },
                              {
                                'col-12':
                                  !this.program.active_campaign ||
                                  !this.program.offers_double_bounty,
                              },
                            ]"
                          >
                            <Impact class="mt-1 mr-1" impact="impact-medium" />
                            <font v-text="$ml.get('medium')">Médio</font>
                          </td>

                          <td
                            :class="[
                              'pl-0',
                              {
                                'col-8':
                                  this.program.offers_double_bounty == true &&
                                  this.program.active_campaign,
                              },
                              {
                                'col-12':
                                  !this.program.active_campaign ||
                                  !this.program.offers_double_bounty,
                              },
                            ]"
                          >
                            <strong>{{
                              program.currency.toUpperCase() === "USDT"
                                ? $utils.convertDollar(program.bounty_medium)
                                : $utils.convertMoney(program.bounty_medium)
                            }}</strong>
                          </td>
                          <td
                            v-if="
                              this.program.offers_double_bounty == true &&
                              this.program.active_campaign
                            "
                            class="col-8 pl-0"
                          >
                            <strong>{{
                              program.currency.toUpperCase() === "USDT"
                                ? $utils.convertDollar(doubleBountyMedium)
                                : $utils.convertMoney(doubleBountyMedium)
                            }}</strong>
                          </td>
                        </tr>

                        <tr class="row">
                          <td
                            :class="[
                              'row',
                              {
                                'col-8':
                                  this.program.offers_double_bounty == true &&
                                  this.program.active_campaign,
                              },
                              {
                                'col-12':
                                  !this.program.active_campaign ||
                                  !this.program.offers_double_bounty,
                              },
                            ]"
                          >
                            <Impact class="mt-1 mr-1" impact="impact-high" />
                            <font v-text="$ml.get('high')">Alto</font>
                          </td>
                          <td
                            :class="[
                              'pl-0',
                              {
                                'col-8':
                                  this.program.offers_double_bounty == true &&
                                  this.program.active_campaign,
                              },
                              {
                                'col-12':
                                  !this.program.active_campaign ||
                                  !this.program.offers_double_bounty,
                              },
                            ]"
                          >
                            <strong>{{
                              program.currency.toUpperCase() === "USDT"
                                ? $utils.convertDollar(program.bounty_high)
                                : $utils.convertMoney(program.bounty_high)
                            }}</strong>
                          </td>

                          <td
                            v-if="
                              this.program.offers_double_bounty == true &&
                              this.program.active_campaign
                            "
                            class="col-8 pl-0"
                          >
                            <strong>{{
                              program.currency.toUpperCase() === "USDT"
                                ? $utils.convertDollar(doubleBountyHigh)
                                : $utils.convertMoney(doubleBountyHigh)
                            }}</strong>
                          </td>
                        </tr>

                        <tr class="row">
                          <td
                            :class="[
                              'row',
                              {
                                'col-8':
                                  this.program.offers_double_bounty == true &&
                                  this.program.active_campaign,
                              },
                              {
                                'col-12':
                                  !this.program.active_campaign ||
                                  !this.program.offers_double_bounty,
                              },
                            ]"
                          >
                            <Impact
                              class="mt-1 mr-1"
                              impact="impact-critical"
                            />
                            <font v-text="$ml.get('critical')">Crítico</font>
                          </td>

                          <td
                            :class="[
                              'pl-0',
                              {
                                'col-8':
                                  this.program.offers_double_bounty == true &&
                                  this.program.active_campaign,
                              },
                              {
                                'col-12':
                                  !this.program.active_campaign ||
                                  !this.program.offers_double_bounty,
                              },
                            ]"
                          >
                            <strong>{{
                              program.currency.toUpperCase() === "USDT"
                                ? $utils.convertDollar(program.bounty_critical)
                                : $utils.convertMoney(program.bounty_critical)
                            }}</strong>
                          </td>
                          <td
                            v-if="
                              this.program.offers_double_bounty == true &&
                              this.program.active_campaign
                            "
                            class="col-8 pl-0"
                          >
                            <strong>{{
                              program.currency.toUpperCase() === "USDT"
                                ? $utils.convertDollar(doubleBountyCritical)
                                : $utils.convertMoney(doubleBountyCritical)
                            }}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="d-flex align-self-start h-profile">
                <div class="v-line d-flex align-items-stretch">
                  <span class="pb-4"></span>
                </div>
              </div>
              <div
                v-if="
                  program.optional_rewards && program.optional_rewards?.length
                "
                class="d-flex align-self-start h-profile-circle"
              >
                <div class="circle d-flex justify-content-center">
                  <span class="circle-internal d-flex justify-content-center"
                    ><span class="circle-primary"></span
                  ></span>
                  <div class="h-line"><span></span></div>
                  <div class="v-line"><span></span></div>
                </div>
                <div class="d-flex flex-column w-100 mr-3">
                  <p class="pl-3 mb-3">
                    <span class="mb-3"
                      > {{$ml.get('otherTypes')}}
                      <span v-text="$ml.get('ofReward')"
                        >de recompensa</span
                      ></span
                    >
                  </p>

                  <div class="card card-body ml-md-3 p-0 d-flex w-100">
                    <table class="mb-2">
                      <thead
                        class="d-flex justify-content-between align-items-center"
                      >
                        <tr>
                          <th
                            class="ml-3 col-24 pl-0"
                            v-text="$ml.get('reward')"
                          >
                            Recompensa
                          </th>
                        </tr>
                        <!-- <svg
                          v-b-tooltip.hover
                          :title="$ml.get('seeOriginalText')"
                          @click="
                            showOriginalDescription = !showOriginalDescription
                          "
                          width="25"
                          height="25"
                          class="mx-2 icon-description"
                        >
                          <image
                            xlink:href="../assets/svg/aa.svg"
                            width="25"
                            height="25"
                          />
                        </svg> -->
                      </thead>
                      <tbody>
                        <tr
                          v-show="!showOriginalDescription"
                          v-for="item in program.translated_optional_rewards"
                          :key="item._id"
                        >
                          <td class="pl-3 col-24 pl-0" v-text="item"></td>
                        </tr>
                        <tr
                          v-show="showOriginalDescription"
                          v-for="(item, index) in program.optional_rewards"
                          :key="index"
                        >
                          <td class="pl-3 col-24 pl-0" v-text="item"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="d-flex align-self-start h-profile">
                <div class="v-line d-flex align-items-stretch">
                  <span class="pb-5"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-24 col-md-7 pl-3">
      <div class=" ">
        <div class="card mb-3" v-show="program.haveCredentials">
          <div class="card-header" v-text="$ml.get('credentials')">
            Credenciais
          </div>
          <div class="card-body py-0 pt-2">
            <div class="d-flex flex-column">
              <div class="pt-3">
                <p class="col">
                  {{ $ml.get("hello") }}
                  <strong>{{ $store.getters["getUser"].username }}</strong
                  >, {{ $ml.get("doYouHaveCredentials") }}
                </p>
              </div>
              <b-row class="justify-content-center pb-3">
                <b-button v-b-modal.modal-confirm-password>{{
                  $ml.get("viewCredentials")
                }}</b-button>
              </b-row>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <CardProgramDetails  v-if="['owner', 'administrator'].includes($store.getters['getUser'].role)" @updateProgram="$emit('getProgram')" :status="program.status"/>
        </div>
        <div class="card mt-3">
          <div class="card-header" v-text="$ml.get('statistics')">
            Estatísticas
          </div>
          <div class="card-body py-0 pt-2">
            <div class="d-flex flex-column">
              <div class="pt-3">
                <h6>
                  <font v-text="$ml.get('reports')">Relatórios</font>:
                  {{ program.amount_of_submited_reports }}
                </h6>
              </div>
              <div class="pt-3">
                <h6>
                  <font v-text="$ml.get('openReports')">Relatórios abertos</font
                  >: {{ program.amount_of_open_reports }}
                </h6>
              </div>
              <div class="pt-3 pb-3">
                <h6>
                  <font v-text="$ml.get('closedReports')"
                    >Relatórios fechados</font
                  >:
                  {{ program.amount_of_closed_reports }}
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div v-show="program.type && program.type != 'vdp'" class="mb-3 mt-3">
          <Ranking :title="$ml.get('programRanking')" />
        </div>
        <div class="mb-3 mt-3">
          <ProgramEfficiency :title="$ml.get('efficiencyMetrics')" />
        </div>
      </div>
    </div>
    <ConfirmPassword :programName="program.name" />
  </div>
</template>
<script>
const moment = require("moment");
import ConfirmPassword from "../components/modais/ConfirmPassword.vue";
import Ranking from "./ranking";
import CardProgramDetails from '../components/CardProgramDetails.vue';

export default {
  props: {
    program: {
      type: Object,
      required: true,
    },
  },

  components: {
    Ranking,
    ConfirmPassword,
    CardProgramDetails
  },
  data() {
    return {
      url: window.location.origin,
      textTolltip: "Copiar link",
      doubleReward: 2,
      showOriginalText: false,
      showOriginalDescription: false,
    };
  },
  methods: {
    copyLink() {
      var hiddenField = document.getElementById("inputSlug");
      hiddenField.select();
      document.execCommand("copy");
      this.textTolltip = "Link copiado!";
    },

    nameLang(name) {
      if (!["-"].includes(name) && name) {
        return this.$ml.get(name.replaceAll("-", ""));
      }
      return name;
    },

    compareDateWeek(date) {
      let week = new Date();
      week.setDate(week.getDate() - 7);

      let dateItem = new Date(date);

      if (moment(dateItem).isBefore(week)) return true;
    },
  },

  computed: {
    doubleBountyMedium() {
      return this.program.bounty_medium * this.doubleReward;
    },
    doubleBountyLow() {
      return this.program.bounty_low * this.doubleReward;
    },
    doubleBountyHigh() {
      return this.program.bounty_high * this.doubleReward;
    },
    doubleBountyCritical() {
      return this.program.bounty_critical * this.doubleReward;
    },
    isThereATarget() {
      return this.program?.target_settings?.targets?.some(
        (it) => it.finishedAt === null,
      );
    },
    targetFinishedAt() {
      return this.program?.target_settings?.targets?.some(
        (it) => it.finishedAt,
      );
    },
    language(){
      const languages = {
        english: 'english',
        spanish: 'spanish',
        portuguese: 'portuguese'
      }

      const getLanguage = localStorage.getItem('vueml-lang');
      return getLanguage === languages.english ? 'en' : getLanguage === languages.spanish ? 'es' : 'pt';
    }
  },
};
</script>
<style scoped>
.icon-aa-svg {
  cursor: pointer;
  position: absolute;
  top: -5px;
  right: 0px;
}
.icon-description {
  cursor: pointer;
}
.bounty {
  font-weight: 500;
  background: #9e9e9e29;
  padding: 3px 10px;
  border-radius: 5px;
}
</style>
